"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promotionalBundleOffers = exports.standardBundleOffers = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var MerchandiseIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

var NonMerchandiseIdProducts = _interopRequireWildcard(require("pricing-pages-unified-ui/constants/NonMerchandiseIdProducts"));

var _standardBundleOffers, _BRAZIL;

var BundledOfferIds = (0, _keyMirror.default)({
  MARKETING_HUB_STARTER: null,
  SALES_HUB_STARTER: null,
  SERVICE_HUB_STARTER: null,
  GROWTH_SUITE_STARTER: null,
  BRAZIL_PROMO_MARKETING_STARTER: null,
  BRAZIL_PROMO_SALES_STARTER: null,
  BRAZIL_PROMO_SERVICE_STARTER: null,
  BRAZIL_PROMO_SALES_PROFESSIONAL: null,
  BRAZIL_PROMO_SERVICE_PROFESSIONAL: null,
  MARCH_2020_PROMO_GROWTH_SUITE: null,
  MARKETING_HUB_STARTER_MC: null,
  GROWTH_SUITE_STARTER_MC: null,
  MARCH_2020_PROMO_GROWTH_SUITE_MC: null
});
var standardBundleOffers = (_standardBundleOffers = {}, (0, _defineProperty2.default)(_standardBundleOffers, MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019, BundledOfferIds.MARKETING_HUB_STARTER), (0, _defineProperty2.default)(_standardBundleOffers, MerchandiseIds.PRODUCT_SALES_STARTER_MAR_2020, BundledOfferIds.SALES_HUB_STARTER), (0, _defineProperty2.default)(_standardBundleOffers, MerchandiseIds.PRODUCT_SERVICE_STARTER_MAR_2020, BundledOfferIds.SERVICE_HUB_STARTER), (0, _defineProperty2.default)(_standardBundleOffers, NonMerchandiseIdProducts.SUITE_STARTER, BundledOfferIds.GROWTH_SUITE_STARTER), (0, _defineProperty2.default)(_standardBundleOffers, NonMerchandiseIdProducts.COVID_PROMO_SUITE_STARTER, BundledOfferIds.MARCH_2020_PROMO_GROWTH_SUITE), (0, _defineProperty2.default)(_standardBundleOffers, MerchandiseIds.PRODUCT_MARKETING_STARTER_MC, BundledOfferIds.MARKETING_HUB_STARTER_MC), (0, _defineProperty2.default)(_standardBundleOffers, NonMerchandiseIdProducts.SUITE_STARTER_MC, BundledOfferIds.GROWTH_SUITE_STARTER_MC), (0, _defineProperty2.default)(_standardBundleOffers, NonMerchandiseIdProducts.SUITE_STARTER_COVID_MC, BundledOfferIds.MARCH_2020_PROMO_GROWTH_SUITE_MC), _standardBundleOffers);
exports.standardBundleOffers = standardBundleOffers;
var promotionalBundleOffers = {
  BRAZIL: (_BRAZIL = {}, (0, _defineProperty2.default)(_BRAZIL, MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019, BundledOfferIds.BRAZIL_PROMO_MARKETING_STARTER), (0, _defineProperty2.default)(_BRAZIL, MerchandiseIds.PRODUCT_SALES_STARTER_MAR_2020, BundledOfferIds.BRAZIL_PROMO_SALES_STARTER), (0, _defineProperty2.default)(_BRAZIL, MerchandiseIds.PRODUCT_SERVICE_STARTER_MAR_2020, BundledOfferIds.BRAZIL_PROMO_SERVICE_STARTER), (0, _defineProperty2.default)(_BRAZIL, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_NOV_2019, BundledOfferIds.BRAZIL_PROMO_SALES_PROFESSIONAL), (0, _defineProperty2.default)(_BRAZIL, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL, BundledOfferIds.BRAZIL_PROMO_SERVICE_PROFESSIONAL), _BRAZIL)
};
exports.promotionalBundleOffers = promotionalBundleOffers;